import { render } from "./ModalSearchKeyContact.vue?vue&type=template&id=71645ec2&scoped=true"
import script from "./ModalSearchKeyContact.vue?vue&type=script&lang=js"
export * from "./ModalSearchKeyContact.vue?vue&type=script&lang=js"

import "../styles/ModalSearchPostalCode.scss?vue&type=style&index=0&id=71645ec2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71645ec2"]])

export default __exports__